import { LayaGL } from "../../../layagl/LayaGL";
import { StatElement } from "../../../layagl/StatisticsContext";
import { WebGLBufferState } from "./WebGLBufferState";
import { WebGLEngine } from "./WebGLEngine";
export class WebGLIndexBuffer {
    constructor(targetType, bufferUsageType) {
        this._glBuffer = this._glBuffer = WebGLEngine.instance.createBuffer(targetType, bufferUsageType);
    }
    _setIndexDataLength(data) {
        var curBufSta = WebGLBufferState._curBindedBufferState;
        if (curBufSta) {
            curBufSta.unBind();
            this._glBuffer.bindBuffer();
            this._glBuffer.setDataLength(data);
            curBufSta.bind();
        }
        else {
            this._glBuffer.bindBuffer();
            this._glBuffer.setDataLength(data);
        }
    }
    setData(buffer, bufferOffset, dataStartIndex, dataCount) {
        let curBufSta = WebGLBufferState._curBindedBufferState;
        if (curBufSta) {
            curBufSta.unBind();
        }
        this._glBuffer.bindBuffer();
        var needSubData = dataStartIndex !== 0 || dataCount !== Number.MAX_SAFE_INTEGER;
        if (needSubData) {
            var subData = new Uint8Array(buffer, dataStartIndex, dataCount);
            this._glBuffer.setData(subData, bufferOffset);
        }
        else {
            this._glBuffer.setData(buffer, bufferOffset);
        }
        if (curBufSta)
            curBufSta.bind();
        LayaGL.statAgent.recordCTData(StatElement.CT_GeometryBufferUploadCount, 1);
    }
    _setIndexData(data, bufferOffset) {
        var curBufSta = WebGLBufferState._curBindedBufferState;
        if (curBufSta) {
            curBufSta.unBind();
            this._glBuffer.bindBuffer();
            this._glBuffer.setData(data, bufferOffset);
            curBufSta.bind();
        }
        else {
            this._glBuffer.bindBuffer();
            this._glBuffer.setData(data, bufferOffset);
        }
        LayaGL.statAgent.recordCTData(StatElement.CT_GeometryBufferUploadCount, 1);
    }
    destroy() {
        this._glBuffer.destroy();
    }
}
